import { Link } from "react-router-dom";
import { categories } from "@/mocks/navCategories";
import { navSites } from "@/mocks/navSites";

const iconBg = [
  "bg-primary-50 text-primary-600",
  "bg-accent-50 text-accent-600",
  "bg-secondary-100 text-secondary-700",
];

export default function CategoryGrid() {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-6">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2">
          <span className="w-1 h-4 rounded-full bg-primary-500" />
          <h2 className="font-heading font-bold text-base md:text-lg text-foreground-950">
            分类快捷入口
          </h2>
          <span className="hidden sm:inline text-xs text-foreground-400">
            按领域一键直达
          </span>
        </div>
        <span className="sm:hidden text-[11px] text-foreground-400 whitespace-nowrap">
          左右滑动查看更多
        </span>
        <Link
          to="/category/life"
          className="hidden sm:flex text-xs text-primary-600 hover:text-primary-700 items-center gap-0.5 cursor-pointer whitespace-nowrap"
        >
          浏览全部分类
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="-mx-4 px-4 md:mx-0 md:px-0 overflow-x-auto no-scrollbar md:overflow-visible">
        <div className="flex md:grid md:grid-cols-3 lg:grid-cols-5 gap-2 md:gap-3 min-w-max md:min-w-0">
          {categories.map((cat, index) => {
            const count = navSites.filter((site) => site.categoryId === cat.id).length;
            return (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="group w-[92px] md:w-auto shrink-0 md:shrink flex flex-col items-center text-center gap-1.5 md:gap-2 py-3 md:py-4 px-2 rounded-lg bg-background-50 border border-background-100 hover:border-primary-300 hover:bg-primary-50/40 transition-colors cursor-pointer"
              >
                <span
                  className={`w-10 h-10 flex items-center justify-center rounded-md ${
                    iconBg[index % 3]
                  } group-hover:scale-105 transition-transform`}
                >
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <span className="text-xs md:text-sm text-foreground-900 group-hover:text-primary-700 whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-[11px] text-foreground-400">{count} 个网址</span>
              </Link>
            );
          })}
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-background-100 flex flex-wrap gap-x-4 gap-y-2">
        {categories.slice(0, 6).map((cat) => (
          <div key={cat.id} className="flex items-center gap-1.5 flex-wrap">
            <span className="text-xs text-foreground-400">{cat.name}：</span>
            {cat.children.map((child) => (
              <Link
                key={child.id}
                to={`/category/${cat.id}`}
                className="text-xs text-foreground-600 hover:text-primary-600 cursor-pointer whitespace-nowrap"
              >
                {child.name}
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}